import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.51 2.65a5.04 5.04 0 0 0-5.042 5.04h.75l-.75-.002v.001a5.027 5.027 0 0 0 5.009 5.043h.032a5.041 5.041 0 0 0 0-10.082M6.967 7.69a3.541 3.541 0 1 1 3.541 3.542h-.029a3.527 3.527 0 0 1-3.512-3.539zm3.541 6.66c-1.821 0-3.596.136-4.94.586-.675.226-1.297.55-1.756 1.027a2.62 2.62 0 0 0-.749 1.87c0 .743.269 1.373.743 1.87.458.48 1.077.807 1.752 1.037 1.342.456 3.118.596 4.95.596 1.726 0 3.409-.122 4.723-.517a4.5 4.5 0 0 1-1.913-1.136c-.834.107-1.786.152-2.81.152-1.798 0-3.369-.142-4.467-.516-.545-.185-.919-.41-1.15-.651a1.14 1.14 0 0 1-.328-.835c0-.348.115-.607.329-.829.231-.24.606-.463 1.153-.646 1.102-.37 2.674-.507 4.463-.507q.801-.001 1.532.04a4.5 4.5 0 0 1 .469-1.473 27 27 0 0 0-2-.067",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.5 12a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.876 15.124 16.5 16.5m-1.376 1.376L16.5 16.5m0 0-1.376-1.376M16.5 16.5l1.376 1.376"
    }, null, -1)
  ]))]))
}
export default { render: render }